export default {
  name: 'Procedure',

  data: () => ({
    steps: []
  }),

  mounted() {
    this.steps.filter(step => step.visible).pop().showDetails = true;
  },

  methods: {
    assignChild(child) {
      this.steps.push(child);
      child.number = this.steps.length;
    },
    removeChild(child) {
      const index = this.steps.findIndex(c => c.number === child.number);
      this.steps.splice(index, 1);
    },
    recalculate(child) {
      this.steps.filter(step => step.visible).forEach((step, idx) => {
        step.number = idx + 1;
      });
      if (child.visible) child.showDetails = true;
    }
  }
};
